var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolaire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M655.77,399.43C655.77,538.37,543.13,651,404.21,651S152.64,538.37,152.64,399.43,265.27,147.85,404.21,147.85,655.77,260.49,655.77,399.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M590.93,178.53,639,112.33a21.23,21.23,0,0,0-34.35-25l-48.06,66.17A288.65,288.65,0,0,1,590.93,178.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M776.55,278.45a21.26,21.26,0,0,0-26.76-13.65L672,290.06a286.06,286.06,0,0,1,13.12,40.39l77.76-25.27A21.25,21.25,0,0,0,776.55,278.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M762.92,493.63l-77.75-25.25a287.23,287.23,0,0,1-13.12,40.38L749.8,534a21.23,21.23,0,0,0,13.12-40.39Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M590.94,620.31a291.48,291.48,0,0,1-34.33,25l48.07,66.14a21.23,21.23,0,0,0,34.35-25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M404.21,688.72c-7.15,0-14.22-.35-21.23-.85v81.82a21.24,21.24,0,1,0,42.47,0V687.87C418.42,688.37,411.35,688.72,404.21,688.72Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.48,620.32,169.4,686.49a21.23,21.23,0,1,0,34.35,25l48.05-66.14A292.43,292.43,0,0,1,217.48,620.32Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.25,468.39,45.51,493.65A21.22,21.22,0,1,0,58.63,534l77.72-25.26A287,287,0,0,1,123.25,468.39Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.35,290.08,58.63,264.82a21.22,21.22,0,1,0-13.12,40.36l77.74,25.27A287,287,0,0,1,136.35,290.08Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M217.48,178.53a288.54,288.54,0,0,1,34.31-25l-48-66.15a21.22,21.22,0,0,0-34.34,24.95Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M404.21,110.12c7.14,0,14.2.35,21.22.87V29.16a21.23,21.23,0,0,0-42.45,0V111C390,110.47,397.06,110.12,404.21,110.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolaire);
export default __webpack_public_path__ + "static/media/Solaire.7a6f7a8623a0e75fcc94d13bf4b07dea.svg";
export { ForwardRef as ReactComponent };